import React, {useEffect, useState} from 'react'
import { Label, Input, Modal, SectionHeading, PaddedContent, Loading, Toolbar, Button, icons } from 'daymap-library';
import { useAuth } from '../../helpers/authContext';

import styles from './Settings.module.scss';

function Settings({onClose, ScheduledCalenders}) {
    const { settings, clientSettings, setClientSettings, saveClientSettings } = useAuth();
    const [originalSettings, setOriginalSettings] = useState({...clientSettings});
    const [settingsDirty, setSettingsDirty] = useState(false);

    const updateClientSetting = (key, value) => {
        const newSettings = {...clientSettings};
        newSettings[key] = value;
        setClientSettings(newSettings);
    }

    const updateClientSettingFromInput = event => {
        updateClientSetting(event.target.id, event.target.value);
    }

    useEffect(() => {
         setSettingsDirty(Object.keys(originalSettings).some(k => originalSettings[k] != clientSettings[k]));
    }, [clientSettings, originalSettings]);

    const saveCicked = () => {        
        saveClientSettings();
        setOriginalSettings({...clientSettings})
    }

    const cancelClicked = () => {
        setClientSettings({...originalSettings});
    }

    if (!settings)
      return <Loading text="Loading settings" />

    const AvailableAppTypes = [
        ...(settings.CheckInEnabled && settings.CheckInModes?.length > 0 ? ['Check In'] : []), //Matches home page availability
        ...(settings.KioskModes?.length > 0 ? ['Kiosk'] : []),
        ...(['Visitors']), // Visitors always displays on the home page
        ...(ScheduledCalenders?.length > 0 ? ['Scheduled Events'] : []),
        ...(settings.RoomModes.length > 0 ? ['Room'] : []),
    ]

    //If the current available app type (defaulting to check in)
    //is not available pick the first avaiable one instead
    //This prevents the page from getting stuck if theres only one available mode
    if(!AvailableAppTypes.includes(clientSettings.defaultAppType))
        {
            updateClientSetting("defaultAppType",AvailableAppTypes[0])
        }

    return (
        <Modal onClose={onClose}>
            <div className={styles.Settings}>
                <SectionHeading>Client Settings</SectionHeading>
                <PaddedContent>
                    <Label text="Default App Type" for="defaultAppType" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultAppType" 
                        config={{options: AvailableAppTypes}} 
                        value={clientSettings.defaultAppType}
                        onChange={updateClientSettingFromInput} />
                    </Label>
                    {clientSettings.defaultAppType === 'Check In' && <Label text="Default Mode" for="defaultCheckInMode" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultCheckInMode" 
                        config={{options: settings.CheckInModes}} 
                        value={clientSettings.defaultCheckInMode}
                        onChange={updateClientSettingFromInput} />
                    </Label>}
                    {clientSettings.defaultAppType === 'Kiosk' && <Label text="Default Mode" for="defaultKioskMode" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultKioskMode" 
                        config={{options: settings.KioskModes}} 
                        value={clientSettings.defaultKioskMode}
                        onChange={updateClientSettingFromInput} />
                    </Label>}
                    {clientSettings.defaultAppType === 'Visitors' && <Label text="Default Location" for="defaultVisitorLocation" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultVisitorLocation" 
                        config={{options: settings.VisitorLocations}} 
                        value={clientSettings.defaultVisitorLocation}
                        onChange={updateClientSettingFromInput} />
                    </Label>}
                    {clientSettings.defaultAppType === 'Scheduled Events' && <Label text="Default Location" for="defaultScheduledEventMode" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultScheduledEventMode" 
                        config={{options: ScheduledCalenders ? ScheduledCalenders.map((x) => {return {value:JSON.stringify(x), text:x.text};}) : []}} 
                        value={clientSettings.defaultScheduledEventMode}
                        onChange={updateClientSettingFromInput} />
                    </Label>}
                    {clientSettings.defaultAppType === 'Room' && <Label text="Default Room" for="defaultRoomMode" position="Top">
                        <Input 
                        elementType="select" 
                        id="defaultRoomMode" 
                        config={{options: settings.RoomModes.map((r) => {return {value: JSON.stringify(r), text: r.Value};})}} 
                        value={clientSettings.defaultRoomMode}
                        onChange={updateClientSettingFromInput} />
                    </Label>}
                    
                    <Label text={`Zoom Amount (${clientSettings.zoomAmount}%)`} position="Top">
                        <Toolbar>
                            <Button 
                            iconClass={icons.ICON_CSS_CLASS.ZoomIn} 
                            secondary 
                            onClick={() => updateClientSetting('zoomAmount', clientSettings.zoomAmount + 10)}></Button>
                            <Button 
                            iconClass={icons.ICON_CSS_CLASS.ZoomOut} 
                            secondary 
                            onClick={() => updateClientSetting('zoomAmount', clientSettings.zoomAmount - 10)}></Button>
                        </Toolbar>
                    </Label>
                    <Toolbar>
                        <Button text="Save" iconClass={icons.ICON_CSS_CLASS.Save} onClick={saveCicked} disabled={!settingsDirty} />
                        <Button text="Cancel" iconClass={icons.ICON_CSS_CLASS.Cancel} secondary onClick={cancelClicked} />
                    </Toolbar>
                </PaddedContent>
            </div>
        </Modal>
    )
}

export default Settings